import { Link } from "react-router-dom";
import Contacts from "@/pages/contacts";
const VisaWorldSection = () => {
  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="newss.jpg" // Replace with the correct path to your image
            lt="Canada Immigrations"
            className="h-full w-full object-cover"
          />
          <div className="absolute bottom-5 left-5  ml-20 text-5xl font-bold text-white drop-shadow-md">
            News
          </div>
        </div>
      </div>
      <section className="bg-gray-50 py-10">
        <div className="container mx-auto flex flex-col items-center gap-6 md:flex-row">
          {/* Image Section */}
          <div className="flex-1">
            <img
              src="/services.jpg"
              alt="Visa World Services"
              className="rounded-md shadow-lg"
            />
          </div>

          {/* Content Section */}
          <div className="flex-1">
            <h2 className="mb-4 text-3xl font-bold text-[#333B69]">
              How has the pandemic impacted the immigration sector?
            </h2>
            <p className="mb-6 text-[#6F7F90]">
              Visa World is among the few trusted immigration service providers,
              offering transparent and ethical immigration solutions. Working in
              collaboration with government-authorized bodies, Visa World
              provides unmatched visa solutions to achieve personalized goals
              for students, families, entrepreneurs and investors. Our
              expertise ensures compliance with immigration laws and a thorough
              understanding of requirements.
            </p>
            <Link
              to="/read-more"
              className="inline-block rounded-md bg-[#F96661] px-6 py-3 font-semibold text-white shadow-md transition-colors hover:bg-[#d65552]"
            >
              Read More ➡️
            </Link>
          </div>
        </div>
      </section>
      <section className="bg-gray-50 py-10">
        <div className="container mx-auto flex flex-col items-center gap-6 md:flex-row-reverse">
          {/* Image Section */}
          <div className="flex-1">
            <img
              src="/cosulting.jpg"
              alt="Visa World Services"
              className="rounded-md shadow-lg"
            />
          </div>

          {/* Content Section */}
          <div className="flex-1">
            <h2 className="mb-4 text-3xl font-bold text-[#333B69]">
              Visa World: Delivering Reliable Immigration Solutions
            </h2>
            <p className="mb-6 text-[#6F7F90]">
              Visa World is a leading name in immigration services, offering
              expert guidance and support for individuals and families seeking
              opportunities abroad. Our team of professionals specializes in
              providing tailored visa solutions for skilled migration, student
              visas, business opportunities and more.
              <br />
              Trust Visa World to simplify your journey and ensure compliance
              with all legal requirements, making your dream of international
              relocation a reality.
            </p>
            <Link
              to="/read-more"
              className="inline-block rounded-md bg-[#F96661] px-6 py-3 font-semibold text-white shadow-md transition-colors hover:bg-[#d65552]"
            >
              Read More ➡️
            </Link>
          </div>
        </div>
      </section>
      <Contacts />
    </>
  );
};

export default VisaWorldSection;
